// extracted by mini-css-extract-plugin
export var container = "_9a-0";
export var error = "_9a-9";
export var label = "_9a-5";
export var light = "_9a-6";
export var md = "_9a-3";
export var sm = "_9a-2";
export var thin = "_9a-8";
export var thinBold = "_9a-7";
export var vertical = "_9a-4";
export var xs = "_9a-1";